/**
 * Hook to consume the PlayfulContext.
 */

import { useContext } from 'react';
import { PlayfulContext, PlayfulContextValue } from './PlayfulContext';

export function usePlayful(): PlayfulContextValue {
  const context = useContext(PlayfulContext);
  if (!context) {
    throw new Error('usePlayful must be used within a PlayfulProvider');
  }
  return context;
}
